import { resultCountStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryResultCount";
import { historyTableProps } from "@store/theme/props/historyTable";

Object.assign(resultCountStyles, {
    orderCountText: historyTableProps.countText,
});
